<script lang="ts" setup></script>

<template>
  <svg fill="none" height="5" viewBox="0 0 17 5" width="17" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.81 0.192V4.676H0.698V0.192H16.81Z" fill="#F40000"></path>
  </svg>
</template>

<style lang="sass" scoped></style>
